module.exports = __webpack_public_path__ + "static/media/PICKME.8f12a129.png";